import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApprovalProcessState {
  visible: boolean;
  data?: any;
}

const initialState: ApprovalProcessState = {
  visible: false,
  data: undefined,
};

const approvalProcessSlice = createSlice({
  name: "approvalProcess",
  initialState,
  reducers: {
    open(state, action: PayloadAction<any>) {
      state.visible = true;
      state.data = action.payload;
    },
    close(state) {
      state.visible = false;
      state.data = undefined;
    },
  },
});

export const {
  open: openApprovalProcessSetupModal,
  close: closeApprovalProcessSetupModal,
} = approvalProcessSlice.actions;

export default approvalProcessSlice.reducer;
